"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnnualProfitAttributable = AnnualProfitAttributable;
exports.AveGrossProfitPast3YearsAmount = AveGrossProfitPast3YearsAmount;
exports.EmployeeIdentity = EmployeeIdentity;
exports.IndustrySector = IndustrySector;
exports.ReplaceEmployeeYears = ReplaceEmployeeYears;
exports.ShortTermAssetsEstimates = ShortTermAssetsEstimates;
var _react = _interopRequireDefault(require("react"));
var _reactBootstrap = require("react-bootstrap");
var _formikMiddleware = _interopRequireDefault(require("../../middleware/formikMiddleware"));
var _KeyEmployeeWizardCalc = require("./KeyEmployeeWizardCalc.config");
var _PopoverAndOverlay = require("../Wizard/PopoverAndOverlay");
var _DropdownForForm = require("../Wizard/DropdownForForm");
var _TextInputForForm = require("../Wizard/TextInputForForm");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function IndustrySector(props) {
  var {
    values,
    setFieldValue
  } = props;
  var label = "What's the industry sector that best describes your business?";
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_DropdownForForm.DropdownForForm, {
    fieldName: "industrySector",
    label: label,
    setFieldValue: setFieldValue,
    values: values,
    placeholderText: "Select One",
    dataArray: _KeyEmployeeWizardCalc.dropdownOptions.industrySectorArray,
    calcName: _KeyEmployeeWizardCalc.calcName
  }));
}
function AveGrossProfitPast3YearsAmount(_ref) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref;
  var fieldName = 'aveGrossProfitPrior3YearsAmount';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '11';
  var placeholder = '0';
  var label = "What was your business's average gross profit over the past 3 years?";
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_KeyEmployeeWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    id: _KeyEmployeeWizardCalc.idPrefix + fieldName,
    label: label,
    values: values,
    setFieldValue: setFieldValue,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    popoverText: _KeyEmployeeWizardCalc.popoverConfig.aveGrossProfitText
  });
}
function ShortTermAssetsEstimates(_ref2) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref2;
  var fieldName = 'shortTermAssetsEstimates';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '11';
  var placeholder = '0';
  var label = "What is the value of your business's estimate short-term assets?";
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_KeyEmployeeWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    id: _KeyEmployeeWizardCalc.idPrefix + fieldName,
    label: label,
    values: values,
    setFieldValue: setFieldValue,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    popoverText: _KeyEmployeeWizardCalc.popoverConfig.shortTermAssetsText
  });
}
function EmployeeIdentity(_ref3) {
  var _errors$arrayName, _touched$arrayName, _errors$arrayName2;
  var {
    errors,
    touched,
    fieldName,
    values,
    arrayName,
    index
  } = _ref3;
  var tealiumName = fieldName + index;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-lg-auto"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, {
    htmlFor: _KeyEmployeeWizardCalc.idPrefix + fieldName + index
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "key-employee-label-text"
  }, " Employee Name ")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.InputGroup, {
    className: "".concat(((_errors$arrayName = errors[arrayName]) === null || _errors$arrayName === void 0 || (_errors$arrayName = _errors$arrayName[index]) === null || _errors$arrayName === void 0 ? void 0 : _errors$arrayName[fieldName]) && ((_touched$arrayName = touched[arrayName]) === null || _touched$arrayName === void 0 || (_touched$arrayName = _touched$arrayName[index]) === null || _touched$arrayName === void 0 ? void 0 : _touched$arrayName[fieldName]) && 'is-invalid')
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    id: "ke_employeeId".concat(index),
    type: "text",
    inputMode: "text",
    name: "employees[".concat(index, "].employeeId"),
    "aria-label": "ke_employeeId".concat(index),
    maxLength: "200",
    value: values[arrayName][index][fieldName],
    onChange: (0, _formikMiddleware.default)().handleChange(),
    onBlur: (0, _formikMiddleware.default)().tealium(_KeyEmployeeWizardCalc.calcName, {
      tealiumName
    }).handleBlur()
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormControl.Feedback, {
    type: "invalid",
    tooltip: true,
    className: "custom-feedback"
  }, (_errors$arrayName2 = errors[arrayName]) === null || _errors$arrayName2 === void 0 || (_errors$arrayName2 = _errors$arrayName2[index]) === null || _errors$arrayName2 === void 0 ? void 0 : _errors$arrayName2[fieldName]))));
}
function AnnualProfitAttributable(_ref4) {
  var _errors$arrayName3, _touched$arrayName2, _errors$arrayName4;
  var {
    errors,
    touched,
    fieldName,
    values,
    arrayName,
    index
  } = _ref4;
  var tealiumName = fieldName + index;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-lg-auto"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, {
    htmlFor: _KeyEmployeeWizardCalc.idPrefix + fieldName + index
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "key-employee-label-text"
  }, "Annual profit attributable to employee \xA0", ' ', /*#__PURE__*/_react.default.createElement(_PopoverAndOverlay.PopoverAndOverlay, {
    text: _KeyEmployeeWizardCalc.popoverConfig.annualProfitAttributableText,
    fieldName: fieldName
  }))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.InputGroup, {
    className: "".concat(((_errors$arrayName3 = errors[arrayName]) === null || _errors$arrayName3 === void 0 || (_errors$arrayName3 = _errors$arrayName3[index]) === null || _errors$arrayName3 === void 0 ? void 0 : _errors$arrayName3[fieldName]) && ((_touched$arrayName2 = touched[arrayName]) === null || _touched$arrayName2 === void 0 || (_touched$arrayName2 = _touched$arrayName2[index]) === null || _touched$arrayName2 === void 0 ? void 0 : _touched$arrayName2[fieldName]) && 'is-invalid')
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    id: "ke_annualProfitAttributable".concat(index),
    "aria-label": "ke_annualProfitAttributable".concat(index),
    className: "keyEmployeeText",
    type: "text",
    inputMode: "numeric",
    maxLength: 3,
    name: "employees[".concat(index, "].annualProfitAttributable"),
    placeholder: '0',
    value: values[arrayName][index][fieldName],
    onChange: (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      zeroAlways: false
    }).handleChange(),
    onBlur: (0, _formikMiddleware.default)().tealium(_KeyEmployeeWizardCalc.calcName, {
      tealiumName
    }).handleBlur()
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "input-group-append"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "input-group-text"
  }, "%"))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormControl.Feedback, {
    className: "custom-feedback",
    type: "invalid",
    tooltip: true
  }, (_errors$arrayName4 = errors[arrayName]) === null || _errors$arrayName4 === void 0 || (_errors$arrayName4 = _errors$arrayName4[index]) === null || _errors$arrayName4 === void 0 ? void 0 : _errors$arrayName4[fieldName]))));
}
function ReplaceEmployeeYears(_ref5) {
  var _errors$arrayName5, _touched$arrayName3, _errors$arrayName6;
  var {
    errors,
    touched,
    fieldName,
    values,
    arrayName,
    index
  } = _ref5;
  var tealiumName = fieldName + index;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-lg-auto"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, {
    htmlFor: _KeyEmployeeWizardCalc.idPrefix + fieldName + index
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "key-employee-label-text"
  }, "Years needed to fully replace employee \xA0", /*#__PURE__*/_react.default.createElement(_PopoverAndOverlay.PopoverAndOverlay, {
    text: _KeyEmployeeWizardCalc.popoverConfig.replaceEmployeeYearsText,
    fieldName: fieldName
  }))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.InputGroup, {
    className: "".concat(((_errors$arrayName5 = errors[arrayName]) === null || _errors$arrayName5 === void 0 || (_errors$arrayName5 = _errors$arrayName5[index]) === null || _errors$arrayName5 === void 0 ? void 0 : _errors$arrayName5[fieldName]) && ((_touched$arrayName3 = touched[arrayName]) === null || _touched$arrayName3 === void 0 || (_touched$arrayName3 = _touched$arrayName3[index]) === null || _touched$arrayName3 === void 0 ? void 0 : _touched$arrayName3[fieldName]) && 'is-invalid')
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    id: "ke_replaceEmployeeYears".concat(index),
    type: "text",
    inputMode: "numeric",
    name: "employees[".concat(index, "].replaceEmployeeYears"),
    "aria-label": "ke_replaceEmployeeYears".concat(index),
    maxLength: "2",
    value: values[arrayName][index][fieldName],
    placeholder: "0",
    onChange: (0, _formikMiddleware.default)().digitFilterChainHandler().handleChange(),
    onBlur: (0, _formikMiddleware.default)().tealium(_KeyEmployeeWizardCalc.calcName, {
      tealiumName
    }).handleBlur()
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormControl.Feedback, {
    type: "invalid",
    tooltip: true,
    className: "custom-feedback"
  }, (_errors$arrayName6 = errors[arrayName]) === null || _errors$arrayName6 === void 0 || (_errors$arrayName6 = _errors$arrayName6[index]) === null || _errors$arrayName6 === void 0 ? void 0 : _errors$arrayName6[fieldName]))));
}